import { AssignWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Assign')
export class AssignNodeSchemaProvider extends SchemaProvider<AssignWorkflowNode> {}
